import { RETAIL_TYPES } from "constants/retailTypes";

export const getRetailerInfo = (
  country: string,
  retailType: string | undefined,
) => {
  if (!retailType || !RETAIL_TYPES[retailType]) {
    return "";
  }
  return RETAIL_TYPES[retailType][country] || RETAIL_TYPES[retailType]["US"];
};
